import CircularProgress from '@mui/material/CircularProgress';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { AuthData, withAuthContext } from '../context/auth';
import { getComparator, HeadCell, Order, stableSort } from '../util/tableUtil';
import { StyledEmptyMessage } from './common/index';
import SortableTable from './SortableTable';

interface Props {
	documents: any[];
	authData: AuthData;
}

interface Data {
	dateCreated: string;
	documentName: any;
}

function createData(dateCreated: string, documentName: any): Data {
	return { dateCreated, documentName };
}

const DocumentsTable = (props: Props) => {
	const { documents, authData } = props;
	const [order, setOrder] = React.useState<Order>('asc');
	const [orderBy, setOrderBy] = React.useState<string>('dateCreated');

	const emptyTable = !documents.length ? (
		<StyledEmptyMessage>No Documents</StyledEmptyMessage>
	) : null;

	const headCells: HeadCell[] = [
		{ id: 'dateCreated', rightAlign: false, label: 'Created Date' },
		{ id: 'documentName', rightAlign: false, label: 'Document Name' },
	];

	const rows: any = documents.map((document: any, index: number) => {
		const display = document.url ? (
			<a href={document.url}>{document.displayName}</a>
		) : (
			<span style={{ display: 'flex', alignItems: 'center' }}>
				{document.displayName}
				<CircularProgress size={15} style={{ marginLeft: '5px' }} />
			</span>
		);
		return createData(
			document.createdTimestamp,
			<a href={document.url}>{display}</a>,
		);
	});

	const rowElements = stableSort(rows, getComparator(order, orderBy)).map(
		(row: any, index: number) => {
			return (
				<TableRow hover tabIndex={-1} key={`${row.documentName}-${index}`}>
					<TableCell scope='row' padding='none'>
						{row.dateCreated
							? authData.getFormattedDate(row.dateCreated)
							: 'N/A'}
					</TableCell>
					<TableCell>{row.documentName}</TableCell>
				</TableRow>
			);
		},
	);

	return (
		<SortableTable
			rows={rowElements}
			headCells={headCells}
			additionalMsg={emptyTable}
			order={order}
			setOrder={setOrder}
			orderBy={orderBy}
			setOrderBy={setOrderBy}
		/>
	);
};

export default withAuthContext<Props>(DocumentsTable);
